import React from 'react';
import cn from "./../../lib/bem";

import './card_component.scss';

const CardComponent = (props) => {
    
    const classes = cn("cardComponent");

    return (
        <div className={classes()}>
            <div className={classes('container')}>
                <div>
                    <img src={props.icono} alt={props.icono} />
                </div>
                <div style={{paddingRight:'20px'}}>
                    <p style={{marginBottom:"10px"}}><b>{props.title}</b></p>
                    <p>{props.desc}</p>
                </div>
            </div>
        </div>
    )

}

export default CardComponent
